function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1DysC", function(module, exports) {
    $parcel$export(module.exports, "EPCheck", ()=>$b9a4b83659379d0e$export$662f3e7de71f1a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $joX8T;
    var $6s1PB;
    var $lpwtK;
    var $2NMNM;
    var $5XoJl;
    var $hJMp3;
    const $b9a4b83659379d0e$export$662f3e7de71f1a7 = ({ onComplete: onComplete, children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('cross-flow-defer-edition-communication');
        const cohort = expConfig.get((0, (0, parcelRequire("joX8T")).COHORT), (0, (0, parcelRequire("joX8T")).NOT_ENROLLED));
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type);
        const [hasMessageStarted, setHasMessageStarted] = (0, $5uXOq.useState)(false);
        const [hasCheckedEpMessage, setHasCheckedEpMessage] = (0, $5uXOq.useState)(false);
        const { start: checkEPMessage } = (0, (0, parcelRequire("hJMp3")).useCoordinationClient)(projectType);
        const isEnrolled = cohort === (0, (0, parcelRequire("joX8T")).VARIATION);
        (0, $5uXOq.useEffect)(()=>{
            setHasCheckedEpMessage(false);
            setHasMessageStarted(false);
        }, [
            projectType
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnrolled || hasCheckedEpMessage || projectType === undefined) return;
            (async ()=>{
                setHasCheckedEpMessage(true);
                const hasStarted = await checkEPMessage();
                (0, (0, parcelRequire("5XoJl")).fireTrackAnalyticsEvent)(createAnalyticsEvent, 'engagementPlatformMessage checked', {
                    projectType: projectType,
                    cohort: cohort,
                    hasCheckedEpMessage: hasCheckedEpMessage,
                    hasEPStarted: hasStarted
                });
                setHasMessageStarted(hasStarted);
                hasStarted && onComplete();
            })();
        }, [
            createAnalyticsEvent,
            checkEPMessage,
            hasCheckedEpMessage,
            isEnrolled,
            onComplete,
            projectType,
            cohort
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, hasMessageStarted && children);
    };
});
parcelRegister("joX8T", function(module, exports) {
    $parcel$export(module.exports, "COHORT", ()=>$a85d1363752adaec$export$3d370c33621572df);
    $parcel$export(module.exports, "NOT_ENROLLED", ()=>$a85d1363752adaec$export$5b7423264d48ab04);
    $parcel$export(module.exports, "CONTROL", ()=>$a85d1363752adaec$export$43f367b3e957f219);
    $parcel$export(module.exports, "VARIATION", ()=>$a85d1363752adaec$export$fa04ad826acc90da);
    var $co1wz;
    const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
    const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
    const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
    const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
    const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
    const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
    const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
    const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
    const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
    const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
        $a85d1363752adaec$export$5b7423264d48ab04,
        $a85d1363752adaec$export$43f367b3e957f219,
        $a85d1363752adaec$export$9ba2bc3b1bdc1519,
        $a85d1363752adaec$export$fa04ad826acc90da,
        $a85d1363752adaec$export$6486974e39493fa6,
        $a85d1363752adaec$export$7d994996134ad562,
        $a85d1363752adaec$export$795e7d69b248dcd0,
        $a85d1363752adaec$export$c9c947c57470b787
    ];
    var $a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);
});
parcelRegister("5XoJl", function(module, exports) {
    $parcel$export(module.exports, "fireButtonAnalytics", ()=>$9f028da2a090e272$export$ac665b9f9662b94a);
    $parcel$export(module.exports, "fireErrorAnalytics", ()=>$9f028da2a090e272$export$a27c21aa3ed8f0f1);
    $parcel$export(module.exports, "fireTrackAnalyticsEvent", ()=>$9f028da2a090e272$export$d5afa3e4b289a23);
    var $8zOmE;
    const $9f028da2a090e272$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked',
            source: 'jira'
        }), actionSubjectId, {
            ...attributes
        });
    };
    const $9f028da2a090e272$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, reason)=>{
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
            source: 'jira'
        }), 'experiment error', {
            reason: reason,
            experimentKey: (0, $ae99efb22fc8caeb$export$a9066c48870ddcc5)
        });
    };
    const $9f028da2a090e272$export$d5afa3e4b289a23 = (createAnalyticsEvent, actionSubjectId, attributes)=>{
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
            source: 'jira'
        }), actionSubjectId, {
            experimentKey: (0, $ae99efb22fc8caeb$export$a9066c48870ddcc5),
            ...attributes
        });
    };
});
const $ae99efb22fc8caeb$export$a9066c48870ddcc5 = 'cross-flow-defer-edition-communication';
parcelRegister("hJMp3", function(module, exports) {
    $parcel$export(module.exports, "useCoordinationClient", ()=>$46416ab3d0500c73$export$ddc368dc94a41e62);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGLgs;
    var $14XJw;
    var $9OXo1;
    var $gXMG7;
    const $46416ab3d0500c73$export$ddc368dc94a41e62 = (projectType)=>{
        const epMessageId = (0, (0, parcelRequire("gXMG7")).useDeferEpMessageKey)(projectType);
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eGLgs")).CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
            cloudId,
            orgId
        ]);
        const start = (0, $5uXOq.useCallback)(async ()=>{
            if (!epMessageId) return false;
            return coordinationClient.start(epMessageId);
        }, [
            epMessageId,
            coordinationClient
        ]);
        const stop = (0, $5uXOq.useCallback)(()=>{
            if (!epMessageId) return false;
            return coordinationClient.stop(epMessageId);
        }, [
            epMessageId,
            coordinationClient
        ]);
        return {
            start: start,
            stop: stop
        };
    };
});
parcelRegister("eGLgs", function(module, exports) {
    $parcel$export(module.exports, "CoordinationClient", ()=>$754c27d37ccd1133$export$580a2294c917898c);
    $parcel$export(module.exports, "default", ()=>$754c27d37ccd1133$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZhen;
    var $jcYbC;
    var $8Mq6c;
    var $TTRxY;
    var $ioD1B;
    var $fG5AJ;
    var $10xFf;
    var $4Pf62;
    var $4R6GH;
    var $j8DrX;
    var $14XJw;
    var $7qPn9;
    const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    class $754c27d37ccd1133$export$580a2294c917898c extends (0, (0, parcelRequire("8Mq6c")).default) {
        constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
            const environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment'));
            const getEnvironmentType = (env)=>{
                if (env === 'prod') return (0, (0, parcelRequire("iZhen")).envType).PROD;
                if (env === 'staging') return (0, (0, parcelRequire("iZhen")).envType).STAGING;
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            };
            const enableChoreographer = (0, (0, parcelRequire("10xFf")).shouldBeChoreographed)({
                messageType: messageType
            }) && !isAlreadyChoreographedAtAncestor;
            const coordinationOptions = {
                enableChoreographer: enableChoreographer,
                envType: getEnvironmentType(environment),
                additionalData: {
                    sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
                }
            };
            super({
                cloudId: cloudId,
                stargateUrl: stargateUrl,
                orgId: orgId,
                isFedRAMPEnvironment: false,
                coordinationOptions: coordinationOptions
            });
            this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
            this.enableChoreographer = enableChoreographer;
            this.onMessageDisposition = onMessageDisposition;
            this.isDebugModeEnabled = (0, (0, parcelRequire("4R6GH")).fg)('ep-external-message-debug-mode');
        }
        async start(messageId) {
            if (this.isDebugModeEnabled) {
                const serverResponse = await super.start(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
                if (!shouldShowMessage) {
                    const didStop = await super.stop(messageId);
                    if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                }
                return shouldShowMessage;
            }
            return this.shouldUseMockClient ? false : super.start(messageId).then((didStart)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STARTED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStart;
            });
        }
        async stop(messageId) {
            return this.shouldUseMockClient ? true : super.stop(messageId).then((didStop)=>{
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).STOPPED : (0, (0, parcelRequire("TTRxY")).MessageDeliveryStatus).BLOCKED);
                return didStop;
            });
        }
    }
    function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const stargateUrl = '/gateway/api';
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
        const { fallback: fallback, messageId: messageId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ioD1B")).ChoreographerContextProvider), {
            isChoreographed: client.enableChoreographer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcYbC")).default), {
            client: client,
            fallback: fallback,
            messageId: messageId
        }, props.children));
    }
});
parcelRegister("ioD1B", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerContextProvider", ()=>$c141e5ba3428702a$export$c3226151caaf2fbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    const $c141e5ba3428702a$var$choreographedStatusContextValue = {
        isAlreadyChoreographedAtAncestor: true
    };
    const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, (0, parcelRequire("fG5AJ")).useChoreographedStatusContext)();
        const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
        return shouldUseChoreographerContextProvider ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fG5AJ")).ChoreographedStatusContext).Provider, {
            value: $c141e5ba3428702a$var$choreographedStatusContextValue
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $4zICj;
    var $8r6xd;
    var $TTRxY;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("8r6xd")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("10xFf", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$36201c75b4df20a7$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "environmentToEnvType", ()=>$36201c75b4df20a7$export$e2cf19200849be9e);
    var $iZhen;
    var $t6tX9;
    function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
        return !!props?.messageType && (0, (0, parcelRequire("t6tX9")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    }
    function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            case 'staging':
                return (0, (0, parcelRequire("iZhen")).envType).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("iZhen")).envType).PROD;
            default:
                return (0, (0, parcelRequire("iZhen")).envType).LOCAL;
        }
    }
});
parcelRegister("t6tX9", function(module, exports) {
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
    const $b5642a17fa90b00d$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
        $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
        $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
    ];
});
parcelRegister("gXMG7", function(module, exports) {
    $parcel$export(module.exports, "useDeferEpMessageKey", ()=>$075dcc142f8ca680$export$46bdb0804933a5fd);
    var $2vSU6;
    var $2tT7R;
    const $075dcc142f8ca680$export$46bdb0804933a5fd = (projectType)=>{
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const isProdEnv = environment === 'prod';
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return isProdEnv ? (0, $ac4f2a72f86d65c9$export$f36bed87d45a98de) : (0, $ac4f2a72f86d65c9$export$a0f8b0f73985911a);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return isProdEnv ? (0, $ac4f2a72f86d65c9$export$475f4ac16b63ff71) : (0, $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea);
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return isProdEnv ? (0, $ac4f2a72f86d65c9$export$58003a8be3bebb14) : (0, $ac4f2a72f86d65c9$export$4b374f476a475bef);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return isProdEnv ? (0, $ac4f2a72f86d65c9$export$b302977ba64b0fa) : (0, $ac4f2a72f86d65c9$export$bfaa609ebcf522b6);
            default:
                return undefined;
        }
    };
});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
